module.exports = __webpack_public_path__ + "static/media/eunion_1.ea38a83e.png";